module.exports = "https://static-production.npmjs.com/26de4581a89de8a6501ce9a3dbb06b85.svg";